import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.544 4.976v-.663a1.653 1.653 0 1 1 3.305 0v.67a5 5 0 0 1 3.334 4.501h.841c.578 0 .975.577.774 1.116l-.844 2.26a.83.83 0 0 1-.774.538H3.192a.83.83 0 0 1-.774-.537l-.844-2.262a.826.826 0 0 1 .774-1.115h.841a5 5 0 0 1 3.355-4.508m2.088-.256v-.407a.435.435 0 0 0-.87 0v.405a5 5 0 0 1 .87.002M4.496 9.484h7.38a3.697 3.697 0 0 0-7.38 0m-.972 2.61-.487-1.305h10.298l-.487 1.305z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })